import { DEFAULT_MAP_BOUNDS, DEFAULT_MAP_CENTER } from './constants';
import type { MultiPolygonCoords, PolygonCoords, PolygonFeature } from './types';

export function computeMapMeta(features: PolygonFeature[]): {
  mapBounds: [[number, number], [number, number]];
  mapCenter: [number, number];
} {
  let minLng = Number.POSITIVE_INFINITY;
  let minLat = Number.POSITIVE_INFINITY;
  let maxLng = Number.NEGATIVE_INFINITY;
  let maxLat = Number.NEGATIVE_INFINITY;

  const updateBounds = (lng: number, lat: number) => {
    minLng = Math.min(minLng, lng);
    minLat = Math.min(minLat, lat);
    maxLng = Math.max(maxLng, lng);
    maxLat = Math.max(maxLat, lat);
  };

  for (const feature of features) {
    if (feature.geometry.type === 'Polygon') {
      for (const ring of feature.geometry.coordinates as PolygonCoords) {
        for (const [lng, lat] of ring) {
          updateBounds(lng, lat);
        }
      }
      continue;
    }

    for (const polygon of feature.geometry.coordinates as MultiPolygonCoords) {
      for (const ring of polygon) {
        for (const [lng, lat] of ring) {
          updateBounds(lng, lat);
        }
      }
    }
  }

  if (!Number.isFinite(minLng) || !Number.isFinite(minLat) || !Number.isFinite(maxLng) || !Number.isFinite(maxLat)) {
    return {
      mapBounds: DEFAULT_MAP_BOUNDS,
      mapCenter: DEFAULT_MAP_CENTER,
    };
  }

  const latPadding = (maxLat - minLat) * 0.08;
  const lngPadding = (maxLng - minLng) * 0.08;

  return {
    mapBounds: [
      [minLat - latPadding, minLng - lngPadding],
      [maxLat + latPadding, maxLng + lngPadding],
    ],
    mapCenter: [(minLat + maxLat) / 2, (minLng + maxLng) / 2],
  };
}
